<div class="flex h-screen bg-gray-100 relative overflow-hidden">

  <!-- Mobile Overlay (Backdrop) - Only visible when mobile sidebar is open -->
  <div *ngIf="isMobileOpen" (click)="toggleMobileSidebar()"
    class="fixed inset-0 bg-black/50 backdrop-blur-sm z-[40] md:hidden transition-opacity">
  </div>

  <!-- Sidebar -->
  <aside class="z-[50] fixed md:static top-0 left-0 h-screen 
          bg-white/90 backdrop-blur-xl
         border-r border-gray-200 shadow-xl transform 
         transition-all duration-300 ease-in-out 
         md:translate-x-0 overflow-y-auto overflow-x-visible" [ngClass]="{
    'w-64': !isSidebarCollapsed,
    'w-20': isSidebarCollapsed,
    'translate-x-0': isMobileOpen,
    '-translate-x-full md:translate-x-0': !isMobileOpen
  }">
    <!-- HEADER -->
    <div
      class="flex items-center justify-between p-4 border-b border-gray-300 bg-white/60 backdrop-blur-md sticky top-0 z-10">
      <h2 *ngIf="!isSidebarCollapsed"
        class="text-sm sm:text-base lg:text-lg xl:text-xl font-semibold text-gray-800 truncate flex items-center gap-2">
        <i class="fa fa-building text-[#c19725]"></i>
        {{ selectedFirmName || 'My Firm' }}
      </h2>

      <button (click)="toggleSidebar()" class="cursor-pointer text-gray-500 hover:text-gray-900 transition">
        <i class="fa" [class.fa-chevron-left]="!isSidebarCollapsed" [class.fa-chevron-right]="isSidebarCollapsed"></i>
      </button>
    </div>

    <!-- Navigation -->
    <nav class="flex flex-col p-3 mt-2 space-y-2 text-gray-700 overflow-y-auto max-h-[calc(100vh-160px)]">
      <!-- Button Template -->
      <button *ngIf="hasSubAccess('/admin-panel/set-type')" (click)="openTab('set-type')" [ngClass]="activeTab === 'set-type'
          ? 'active-nav'

          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-user-cog" style="font-size:25px; color:black;"></i>
        <span *ngIf="!isSidebarCollapsed">Login, Sell & Logo</span>
      </button>

      <button *ngIf="hasCategoryAccess()" (click)="openTab('add-category')" [ngClass]="activeTab === 'add-category'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-layer-group" style="font-size:25px; color:green;"></i>
        <span *ngIf="!isSidebarCollapsed">Add Category</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/dropdown-setting')" (click)="openTab('dropdown-setting')" [ngClass]="activeTab === 'dropdown-setting'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-sliders-h" style="font-size:25px; color:red;"></i>
        <span *ngIf="!isSidebarCollapsed">Customize Settings</span>
      </button>

      <button *ngIf="hasKalakarAccess()" (click)="openTab('kalakar-setting')" [ngClass]="activeTab === 'kalakar-setting'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-users" style="font-size:25px; color:olive;"></i>
        <span *ngIf="!isSidebarCollapsed">Karigar List</span>
      </button>

      <!-- <button
        (click)="openTab('Invoice Layout')"
        [ngClass]="activeTab === 'Invoice Layout'
          ? 'active-nav'
          : 'nav-btn'"
        class="nav-item text-sm md:text-base lg:text-lg"
      >
        <i class="fa fa-file-invoice-dollar" style="font-size:25px; color:skyblue;"></i>
        <span *ngIf="!isSidebarCollapsed">Invoice</span>
      </button> -->

      <button *ngIf="hasSubAccess('/admin-panel/rough-estimate-customization')" (click)="openTab('Rough Estimate')" [ngClass]="activeTab === 'Rough Estimate'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-file-invoice-dollar" style="font-size:25px; color:skyblue;"></i>
        <span *ngIf="!isSidebarCollapsed">Rough Estimate</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/asset-form')" (click)="openTab('Add Assets')" [ngClass]="activeTab === 'Add Assets'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-gem" style="font-size:25px; color:blue;"></i>
        <span *ngIf="!isSidebarCollapsed">Assets</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/rate-List')" (click)="openTab('Rate List')" [ngClass]="activeTab === 'Rate List'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-rupee-sign" style="font-size:25px; color:rgb(156, 0, 0);"></i>
        <span *ngIf="!isSidebarCollapsed">Rate List</span>
      </button>


      <button *ngIf="role !== 'Staff'" (click)="openTab('stafflistadmin')" [ngClass]="activeTab === 'stafflistadmin'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-user-tie" style="font-size:25px; color:black;"></i>
        <span *ngIf="!isSidebarCollapsed">Staff List</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/whatsapp-instance')" (click)="openTab('whatsapp-instance')" [ngClass]="activeTab === 'whatsapp-instance'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fab fa-whatsapp text-[20px]" style="font-size:25px; color:green;"></i>
        <span *ngIf="!isSidebarCollapsed">WhatsApp Instance</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/expense-type')" (click)="openTab('expense-type')" [ngClass]="activeTab === 'expense-type'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-receipt" style="font-size:25px; color:slategrey;"></i>
        <span *ngIf="!isSidebarCollapsed">Add Expense Type</span>
      </button>

      <button *ngIf="hasSubAccess('/admin-panel/weighing-scale-setting')" (click)="openTab('weighing-scale-setting')" [ngClass]="activeTab === 'weighing-scale-setting'
          ? 'active-nav'
          : 'nav-btn'" class="nav-item text-sm md:text-base lg:text-lg">
        <i class="fa fa-weight-hanging" style="font-size:25px; color:goldenrod;"></i>
        <span *ngIf="!isSidebarCollapsed">Weighing Scale</span>
      </button>

    </nav>

    <!-- LOGOUT -->
    <div class="mt-auto border-t border-gray-300 p-4 text-center bg-white/60 sticky bottom-0">
      <button (click)="logout()"
        class="cursor-pointer logout-btn w-full text-red-600 flex items-center justify-center gap-2 px-3 py-2 bg-red-50 hover:bg-white rounded-lg transition">
        <i class="fa fa-sign-out-alt"></i>
        <span *ngIf="!isSidebarCollapsed">Logout</span>
      </button>
    </div>
  </aside>

  <!-- MAIN CONTENT -->
  <main class="flex-1 overflow-x-hidden overflow-y-auto p-3 sm:p-4 md:p-6 relative z-0">
    <!-- HEADER -->
    <header class="relative z-[30] flex justify-between items-center mb-4 md:mb-6 gap-2">
      <h1
        class="text-xs sm:text-sm md:text-base lg:text-lg xl:text-[22px] font-bold text-gray-800 flex items-center gap-2 truncate">
        <i class="fa fa-user-circle text-[#c19725] shrink-0"></i>
        <span class="truncate">{{ userName ? 'Welcome, ' + userName : 'Settings Panel' }}</span>
      </h1>

      <div class="flex items-center gap-2 shrink-0">
        <!-- Firm Badge -->
        <span
          class="bg-[#c19725] text-white text-[10px] sm:text-xs md:text-sm lg:text-base px-2 sm:px-3 py-1 rounded-full shadow whitespace-nowrap"
          *ngIf="selectedFirmName">
          {{ selectedFirmName }}
        </span>

        <!-- MOBILE MENU -->
        <button class="md:hidden p-2 text-gray-700 text-lg hover:bg-gray-200 rounded-lg transition"
          (click)="toggleMobileSidebar()">
          <i class="fa" [class.fa-bars]="!isMobileOpen" [class.fa-times]="isMobileOpen"></i>
        </button>
      </div>
    </header>

    <!-- CONTENT CARD -->
    <section class="glass-card min-h-[calc(100vh-120px)] relative z-[1] p-2 xl:p-4 rounded-2xl shadow-lg border
                border-white/30 bg-white/60 backdrop-blur-xl overflow-x-hidden">

      <div class="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">

        <img [src]="logoImage || '/assets/images/rate-list/rate-list3.png'" alt="logo" class="w-[200px] sm:w-[250px] md:w-[400px] xl:w-[600px]
                 opacity-5 object-contain" />

      </div>

      <div class="relative z-[2]">
        <router-outlet></router-outlet>
      </div>
    </section>

  </main>

</div>